import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { CareRecipientWithDataSyncInformation } from "../../../../../domain/care_recipient/CareRecipientWithDataSyncInformation";
import { CareRecipientId } from "../../../../../domain/care_recipient/CareRecipientId";
import { useViewableCareRecipient } from "../../../../hooks/admin/user/useViewableCareRecipient";

export const ViewableCareRecipientCheckComponent = React.memo(function ViewableCareRecipientCheckComponent(props: ViewableCareRecipientCheckComponentProps) {
    const { careRecipientList, whenCareRecipientChanged } = props;

    const [careRecipients, setCareRecipients] = useState<string[]>([]);

    const viewableCareRecipients = useViewableCareRecipient();

    useEffect(() => {
        if (viewableCareRecipients) {
            setCareRecipients(viewableCareRecipients.map(viewableCareRecipient => viewableCareRecipient.id.value));
        }
    }, [viewableCareRecipients, setCareRecipients]);

    useEffect(() => {
        whenCareRecipientChanged(careRecipients);
    }, [careRecipients, whenCareRecipientChanged]);

    const handleCareRecipientChanged = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        let newList = [...careRecipients];
        if (newList.includes(e.target.value)) {
            newList = newList.filter(careRecipient => careRecipient !== e.target.value);
        } else {
            newList.push(e.target.value);
        }
        setCareRecipients(newList);
        whenCareRecipientChanged(newList);
    }, [careRecipients, whenCareRecipientChanged]);

    const isMatchedCareRecipient = useCallback((careRecipientId: CareRecipientId) => careRecipients.includes(careRecipientId.value), [careRecipients]);

    return (
        <div className={"viewable_care_recipients"}>
            {careRecipientList.map((it) => (
                <div key={it.careRecipient.id.value} className={"viewable_care_recipient"}>
                    <div className={"check_box_row"}>
                        <label className="check_box">
                            <input type="checkbox" value={it.careRecipient.id.value} checked={isMatchedCareRecipient(it.careRecipient.id)} onChange={handleCareRecipientChanged} />
                            <span className="icon_checked"/>
                            {it.careRecipient.houseId?.value}:{it.careRecipient.name.value}
                        </label>
                    </div>
                </div>
            ))}
        </div>
    );
});

export type ViewableCareRecipientCheckComponentProps = {
    careRecipientList: CareRecipientWithDataSyncInformation[],
    whenCareRecipientChanged: (newList: string[]) => void;
};
